export default "/staticreactui/static/media/static/media/translator6.d7ad5723.webp";